/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {
    // Set mails flag unread to true
    createOnlineTest({ commit }, payload) {
      var frm = new FormData()
      // var onlineTestInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail, "workspace_id": payload.workspace_id}
      const json = JSON.stringify(payload.param)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      for (var index in payload.files) {
        frm.append(index, payload.files[index])
      }
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/create", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_ONLINETEST", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    updateOnlineTest({ commit }, payload) {
      var frm = new FormData()
      for (var index in payload.files) {
        frm.append(index, payload.files[index])
      }
      // var onlineTestInfo = {"id": payload.id, "title": payload.title, "size": payload.files.length, "files":files,  "detail": payload.detail}
      const json = JSON.stringify(payload.param)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/update", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success') {
            commit("UPDATE_ONLINETEST", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteOnlineTestFile({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/online-test/update/"+ payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("UPDATE_ONLINETEST", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteOnlineTest({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/online-test/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_ONLINETEST", payload)
            }
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    onlineTestFileDonwload(context, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/online-test/download/"+ payload.param, {responseType: 'blob'}).then((response)=>{
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          // const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ')
          link.setAttribute('download', payload.name);
          document.body.appendChild(link);
          link.click();
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    getOnlineTest({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/online-test/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_ONLINETEST_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    setOnlineTestSearchQuery({ commit }, query){
        commit("SET_ONLINETEST_SEARCH_QUERY", query)
    },
    getOnlineTestMember({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/online-test/member/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_ONLINETEST_MEMBER_LIST", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    createOnlineTestMember({commit}, payload) {
      var frm = new FormData()
      var onlineTestInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail, "workspace_id": payload.workspace_id}
      const json = JSON.stringify(onlineTestInfo);
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      frm.append("file", payload.file)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/member/create", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_ONLINETEST_MEMBER", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteOnlineTestMember({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/online-test/member/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_ONLINETEST_MEMBER", payload)
              resolve(response)
            }
            reject(response)
          }
        ).catch((error) => { reject(error) })
      })
    },
    updateOnlineTestMemberScore({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/member/update/score", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_ONLINETEST_MEMBER_SCORE", payload)
              resolve(response)
            }
            reject(response)
          }
        ).catch((error) => { reject(error) })
      })
    },
    updateOnlineTestMember({ commit }, payload) {
      var frm = new FormData()
      var onlineTestInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail}
      const json = JSON.stringify(onlineTestInfo);
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      frm.append("file", payload.file)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/member/update", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("UPDATE_ONLINETEST_MEMBER", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    fileDonwloadOnlineTestMembe(context, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/online-test/member/download/"+ payload.param, {responseType: 'blob'}).then((response)=>{
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', payload.name)
          // link.download = payload.name
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          link.remove()
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    fileCompressOnlineTestMembe(context, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/online-test/member/compress", payload).then((response)=>{
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    }

}
